module.exports = __webpack_public_path__ + "static/media/south-africa.7e9b35ab.svg";